import useDevice from '@hooks/useDevice';
import { observer } from 'mobx-react-lite';
import React from 'react';
import BasicMobileDrawer from './BasicMobileDrawer';
import BasicWebDrawer from './BasicWebDrawer';

interface BasicDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    header?: JSX.Element;
    children: JSX.Element;
}

const BasicDrawer: React.FC<BasicDrawerProps> = observer(({ isOpen, onClose, header = undefined, children }) => {
    const { isMobileDevice } = useDevice();
    return (
        isMobileDevice
            ? <BasicMobileDrawer isOpen={isOpen} onClose={onClose} header={header}>
                {children}
            </BasicMobileDrawer>
            : <BasicWebDrawer isOpen={isOpen} onClose={onClose} header={header}>
                {children}
            </BasicWebDrawer>
    )
})

export default BasicDrawer;